export function deDuplicateDiscountCoupons(discountCouponsOnly) {
    const deDuppedDiscounts = {};
    discountCouponsOnly.forEach((couponData) => {
        const key = `${couponData.coupon_name}-${couponData.amount}`;
        if (!deDuppedDiscounts[key]) {
            deDuppedDiscounts[key] = {
                coupon_name: couponData.coupon_name,
                amount: 0,
            }
        }
        deDuppedDiscounts[key].amount += couponData.amount;
    })
    return deDuppedDiscounts;
}
